import { render, staticRenderFns } from "./pageAutoClose.vue?vue&type=template&id=7318257f&scoped=true"
import script from "./pageAutoClose.vue?vue&type=script&lang=js"
export * from "./pageAutoClose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7318257f",
  null
  
)

export default component.exports